import React from 'react'
import { Card, Col, Row } from 'react-bootstrap'

const ClientStats = () => {
  return (
   <>
   <Row>
   <Col lg="4">
     <Card className="card-main media mb-3 h-100">
       <div className="media-body">
         <h3>Inspectors</h3>
         <div className="count">78</div>
       </div>
     </Card>
   </Col>
   <Col lg="4">
     <Card className="card-main media bg-red  h-100  mb-3">
       <div className="media-body">
         <h3>Councils</h3>
         <div className="count">136</div>
       </div>
     </Card>
   </Col>
   <Col lg="4">
     <Card className="card-main media  bg-indigo  h-100 mb-3">
       <div className="media-body">
         <h3>Surveys</h3>
         <div className="count">136</div>
       </div>
     </Card>
   </Col>
 </Row>
   </>
  )
}

export default ClientStats